import angular, { IController } from 'angular';

class MaintenanceReportsController implements IController {}

MaintenanceReportsController.$inject = [];
angular
  .module('flowingly.runner.maintenance')
  .controller('maintenanceReportsController', MaintenanceReportsController);
